import React from 'react';
import 'styles/footer.scss';
import { Link } from 'react-router-dom';

export const Footer = () => (
  <footer className="footer-container color-scheme-dark">
    <div className="container main-footer">
      <div className="vc_row wpb_row vc_row-fluid">
        <div className="wpb_column vc_column_container vc_col-sm-4">
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="title-wrapper wd-wpb set-mb-s reset-last-child wd-title-color-default wd-title-style-default text-left footer-title wd-underline-colored">
                <div className="liner-continer">
                  <h4 className="woodmart-title-container title  wd-font-weight- wd-fontsize-l">Наши услуги:</h4>
                </div>
              </div>
              <div className="vc_row wpb_row vc_inner vc_row-fluid">
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div className="vc_wp_custommenu wpb_content_element footer-menu">
                        <div className="widget widget_nav_menu">
                          <div className="menu-footer-uslugi1-container">
                            <ul id="menu-footer-uslugi1" className="menu">
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/photos">Фотографии</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/fotobooks">ФотоКниги</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/calendars">Календари</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/postcards">Открытки</Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div className="vc_wp_custommenu wpb_content_element footer-menu">
                        <div className="widget widget_nav_menu">
                          <div className="menu-footer-uslugi2-container">
                            <ul id="menu-footer-uslugi2" className="menu">
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/decor">Декор Интерьера</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/souvenirs">Фотосувениры</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/clothes">Одежда с Фото</Link>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <Link to="/products/certificates">Подарочные сертификаты</Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wpb_column vc_column_container vc_col-sm-4">
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="title-wrapper wd-wpb set-mb-s reset-last-child  wd-rs-65bc97daf239d wd-title-color-default wd-title-style-default text-left footer-title  wd-underline-colored">
                <div className="liner-continer">
                  <h4 className="woodmart-title-container title  wd-font-weight- wd-fontsize-l">ФотоПочта</h4>
                </div>
              </div>

              <div className="vc_row wpb_row vc_inner vc_row-fluid">
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div className="vc_wp_custommenu wpb_content_element footer-menu">
                        <div className="widget widget_nav_menu">
                          <div className="menu-footer-about1-container">
                            <ul id="menu-footer-about1" className="menu">
                              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-789">
                                <a href="https://www.fotopostapp.ru/o-fotopochte/">О ФотоПочте</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-786">
                                <a href="https://www.fotopostapp.ru/akczii/">Акции</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-788">
                                <a href="https://www.fotopostapp.ru/sdelaem-za-vas/">Сделаем за вас</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-787">
                                <a href="https://www.fotopostapp.ru/biznesu/">Бизнесу</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div className="vc_wp_custommenu wpb_content_element footer-menu">
                        <div className="widget widget_nav_menu">
                          <div className="menu-footer-about2-container">
                            <ul id="menu-footer-about2" className="menu">
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <a href="https://www.fotopostapp.ru/reviews/">Отзывы</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <a href="https://www.fotopostapp.ru/faq/">FAQ</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <a href="https://www.fotopostapp.ru/franshiza/">Франшиза</a>
                              </li>
                              <li className="menu-item menu-item-type-post_type menu-item-object-page">
                                <a href="https://www.fotopostapp.ru/podderzhka-i-kontakty/">Поддержка и контакты</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="wpb_column vc_column_container vc_col-sm-4">
          <div className="vc_column-inner">
            <div className="wpb_wrapper">
              <div className="vc_row wpb_row vc_inner vc_row-fluid">
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div id="wd-65bf28c9edbba" className="wd-image wd-wpb wd-rs-65bf28c9edbba text-right ">
                        <img
                          width="117"
                          height="117"
                          src="https://www.fotopostapp.ru/wp-content/uploads/2024/02/qrcod.png"
                          className="attachment-full size-full"
                          alt=""
                          decoding="async"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container vc_col-sm-6">
                  <div className="vc_column-inner">
                    <div className="wpb_wrapper">
                      <div id="wd-661e3ace6f557" className="wd-image wd-wpb wd-rs-661e3ace6f557 text-center ">
                        <a href="https://apps.apple.com/us/app/%D1%84%D0%BE%D1%82%D0%BE%D0%BF%D0%BE%D1%87%D1%82%D0%B0-%D1%84%D0%BE%D1%82%D0%BE-%D0%B8-%D1%84%D0%BE%D1%82%D0%BE%D0%BA%D0%BD%D0%B8%D0%B3%D0%B0/id864842646">
                          <img
                            width="102"
                            height="34"
                            src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/appsm.png"
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </a>
                      </div>
                      <div id="wd-6626d26ce0b32" className="wd-image wd-wpb wd-rs-6626d26ce0b32 text-center ">
                        <a href="https://play.google.com/store/apps/details?id=com.tartugo.FotoPostAppRus">
                          <img
                            width="102"
                            height="29"
                            src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/gpsm.png"
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </a>
                      </div>
                      <div id="wd-6626d288cffc1" className="wd-image wd-wpb wd-rs-6626d288cffc1 text-center ">
                        <a href="https://appgallery.huawei.com/app/C102709057">
                          <img
                            width="102"
                            height="34"
                            src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/apgalsm.png"
                            className="attachment-full size-full"
                            alt=""
                            decoding="async"
                            loading="lazy"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="copyrights-wrapper copyrights-two-columns">
      <div className="container">
        <div className="min-footer">
          <div className="col-left set-cont-mb-s reset-last-child">
            <p>
              © 2024 <a href="https://www.fotopostapp.ru/">FotoPostApp</a>. All rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
